import User16 from '@carbon/icons-react/es/user/16';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Avatar } from 'components/atoms/avatar';
import { AvatarProps as AtomAvatarProps } from 'components/atoms/avatar/types';
import { initials } from 'utils/initials';

export interface AvatarProps extends Omit<AtomAvatarProps, 'src'> {
  isCustomerRole: boolean;
  content?: string | ReactNode;
  className?: string;
  name?: string;
}

const StyledAvatar = styled(Avatar)<AvatarProps>`
  border-width: 1px !important;
  border-style: dashed !important;
  border-color: ${({ isCustomerRole }) =>
    isCustomerRole ? 'var(--magenta-50)' : 'var(--blue-60)'} !important;
  background-color: ${({ isCustomerRole }) =>
    isCustomerRole ? 'var(--magenta-20)' : 'var(--blue-20)'} !important;
  .ant-avatar-string {
    color: ${({ isCustomerRole }) =>
      isCustomerRole ? 'var(--magenta-50)' : 'var(--blue-60)'} !important;
  }
`;

export const PlaceholderAvatar: FC<AvatarProps> = ({
  isCustomerRole = false,
  className,
  size = 'default',
  name = '',
  icon = (
    <User16 color={isCustomerRole ? 'var(--magenta-50)' : 'var(--blue-60)'} />
  ),
  ...rest
}) => {
  const hasName = name.length > 0;

  return (
    <StyledAvatar
      isCustomerRole={isCustomerRole}
      className={className}
      icon={!hasName && icon}
      size={size}
      name={name}
      isPlaceholder
      {...rest}
    >
      {hasName && initials(name)}
    </StyledAvatar>
  );
};
